import { trigger, transition, style, animate } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import videojs from 'video.js';
import { RouterFlowService } from '../../services/router-flow.service';
import { SliderService } from '../../services/slider.service';
import { SettingsService } from '../../services/settings.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-streaming-player',
  templateUrl: './streaming-player.component.html',
  styleUrls: ['./streaming-player.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class StreamingPlayerComponent implements OnInit {
  url: SafeResourceUrl =
    'https://genybetlivehls.akamaized.net/hls/live/2010069/genylive/master.m3u8';
  channelEmbedType = 'live';

  channels;
  isBrowser = false;
  sliders: any = [];
  showCarousel = true;
  isHomepage: boolean;
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 5,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
      numScroll: 2,
    },
  ];
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private domSanitizer: DomSanitizer,
    public router: Router,
    private sliderService: SliderService,
    private routerFlowService: RouterFlowService,
    private settingServ: SettingsService
  ) {
    router.events.subscribe((val) => {
      router.url === '/' || router.url === '/?siteAdmin=true'
        ? (this.isHomepage = true)
        : (this.isHomepage = false);
    });

    this.routerFlowService.getRedirectInfo().subscribe((isRedirected) => {
      if (isRedirected) {
        this.showCarousel = false;
        router.events.subscribe((val) => {
          if (val instanceof NavigationEnd) this.showCarousel = true;
        });
      }
    });
  }

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.getSliders();
      this.getStreaming();
    }
  }

  getSliders(): any {
    this.sliderService.getSlideInfo().subscribe((slide) => {
      const data = !slide.error ? slide.data : null
      data?.sort((a: { sort: number }, b: { sort: number }) => {
        if (a.sort > b.sort) {
          return 1;
        }
        if (a.sort < b.sort) {
          return -1;
        }
        return 0;
      });

      this.sliders = data;

      this.sliders.forEach((slider) => {
        if (
          this.settingServ.filterRaceCountries(slider?.page_url.split('/')[1])
        ) {
          slider.page_url = '';
        }
      });
    });
  }

  getStreaming() {
    this.sliderService.getStreamingList().subscribe((resp) => {
      this.channels = resp;
      if (this.channels?.length > 0) {
        this.url = this.sanitizeUrl(this.channels[0]?.channelStreamSource);
        this.channelEmbedType = this.channels[0]?.channelEmbedType;
      }
    });
  }

  startVideo(url, channelEmbedType) {
    this.channelEmbedType = channelEmbedType;
    this.url = this.sanitizeUrl(url);

    const player = videojs('my-video', {});
    if (channelEmbedType !== 'iframe') {
      player.src([{ src: url }]);
      player.play();
    } else {
      player.pause();
    }
  }

  sanitizeUrl(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onTabClose(): any {
    this.showCarousel = true;
    videojs('my-video', {}).pause();
  }

  onTabOpen(): any {
    this.showCarousel = false;
  }
}
